export let post_config = [
    {
        elements: [
            {
                elementGetParamMap: 'test_filter_select',
                elementCat: 'cat_position',
                elementType: 'select',
                element_model: '',
                label: 'Канал',
                placeholder: 'Выбрать канал',
                filterable: true,
                options: [
                    { value: '1', label: 'Канал 1', },
                    { value: '2', label: 'Канал 2', },
                    { value: '3', label: 'Канал 3', },
                ]
            },
            {
                elementGetParamMap: 'test_input',
                element_model: '',
                elementType: 'textarea',
                placeholder: 'Добавьте заголовок',
                label: 'Заголовок'
            },
            {
                elementGetParamMap: 'test_input',
                element_model: '',
                elementType: 'textarea',
                placeholder: 'Добавьте текст публикации',
                label: 'Текст публикации'
            },
            {
                elementGetParamMap: 'test_checkbox',
                elementType: 'checkbox',
                element_model: true,
                placeholder: '',
                label: 'Сохранить как черновик',
            },
            {
                elementGetParamMap: 'file',
                element_model: '',
                elementType: 'file-upload',
                type: 'file',
                multiple: false,
                acceptMime: 'file/*',
                uploadApi: {},
                delApi: {},
            }


        ]
    }
]